/**
 * Cart Drawer — delegated listener for terms checkbox
 * Works with dynamically injected cart drawer content.
 */
document.addEventListener('change', function(e){
  const checkbox = e.target.closest('input[type="checkbox"][name="agree_terms"]');
  if(!checkbox) return;

  const checkoutBtn = document.querySelector('[data-checkout-button], .cart__checkout');

  if(checkoutBtn){
     checkoutBtn.disabled = !checkbox.checked;
     checkoutBtn.classList.toggle('is-disabled', !checkbox.checked);
  }

});
